
export default {
  state: {
    // task: {
    //   companyCode: "",
    //   primaryOperationCode: "",
    //   secondaryOperationCode: "",
    // },
    jobs: {
      logo: "",
      JobTitle: "",
      Company: "",
      Salary: "",
      JobLocation: "",
      JobType: "",
      JobDescripton: ""
    },
    // username: '',
    // messages: [],
    user_id: '',
    // users: [],
    // activeusersid: [],
    // token: localStorage.getItem('token') || ''

  },

  // In your Vuex store

  mutations: {
    // use to show or hide edit mode
    // setTask(state, data) {
    //   state.task = data;
    // },
    setJobs(state, data) {
      state.jobs = data;
    },
  },
  getters: {
    // getTask: (state) => state.task,
    getJobs: (state) => state.jobs,
  },
};
